module.exports = __webpack_public_path__ + "static/media/WEB1.d08d0b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB1.jpg
// module id = 80
// module chunks = 0